import theme from '@styles/theme';
import reusables from '@styles/theme/reusables';
export default {
  modalButton: isExpanded => ({
    position: 'absolute',
    display: 'flex',
    flexDirection: 'row',
    bottom: '20px',
    right: ['auto', 'auto', 'auto', 'auto', '22px'],
    left: ['22px', '22px', '22px', '22px', 'auto'],
    zIndex: theme.zIndex.documentUp,
    background: 'transparent',
    color: 'neutralWhite',
    border: 'none',
    outline: 'none',
    cursor: 'pointer',
    justifyContent: 'center',
    ...reusables.mainTransition('transform', 'cubic-bezier(.4,0,.2,1)', '.48s'),
    transform: isExpanded ? 'translateX(0)' : ['translateX(0)', 'translateX(0)', 'translateX(0)', 'translateX(0)', 'translateX(calc(100% - 39px))'],
    alignItems: 'center'
  }),
  modalButtonText: isExpanded => ({
    opacity: [1, 1, isExpanded ? 1 : [1, 1, 1, 1, 0]],
    ...reusables.mainTransition('opacity', 'cubic-bezier(.4,0,.2,1)', '.48s', '.12s'),
    fontSize: theme.fontSizes.text,
    fontFamily: theme.fonts.uniform,
    letterSpacing: theme.letterSpacings.caps,
    fontWeight: theme.fontWeights.normal,
    lineHeight: '140%',
    textTransform: 'uppercase'
  }),
  cartIcon: {
    mr: '17px'
  }
};